import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-AM-logo_svg__svg8",
  viewBox: "0 0 82.37 64.62"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-AM-logo_svg__cls-1{fill:#0c2f59}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-AM-logo_svg__path18",
      d: "M56.86 19.55c1.29.01 2.17.4 2.88.73 1.49.71 3.23 1.52 5.42 2.58 0 0 3.52-2.51 3.71-2.64 1.2-.81 2.36-.19 2.73.51 1.32 2.48 3.74 7.63 5.02 12.35.15.57-.03 1.44-.91 1.71-.51.14-1.39.27-2.3.39-1.28.16-1.26 1.19-1.26 1.82 0 .78.01 5.97.01 7.75.03 1.09-.8 4.66-4.93 4.66h-9.4c-3.56.01-6.42-3-6.44-6.19V24.84c.02-3.17 2.86-5.31 5.46-5.27",
      class: "svg-AM-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-AM-logo_svg__path20",
      d: "M41.98 49.4H11.41v3.4h35.87s1.3-3 1.3-6.33l.01-23.05c0-1.82.74-4.89 4.47-5.71.1-.02.21-.04.32-.06 10.59-2.5 21.5-.22 27.66 2.43 1.1.54 1.36-.34 1.32-.72.13-5.18-3.81-11.09-11.05-11.44-5.89-.14-9.15 1.97-10.35 2.56-.1.05-.25.03-.38-.12-1.08-1.07-3.4-2.67-6-3.41-.39-.09-.42-.66.02-.71 5.57-.6 10.45.04 12.48.36.47.08.83-.19.64-.63-.15-.33-.26-.48-.5-.99-.5-1.07-1.81-2.2-3.47-2.66C59.37 1.09 51.91.04 45.28 0 37.8-.05 29.92 1.44 27.93 1.9c-.48.1-1.15.27-1.27.29-.54.11-.67.63-.43.88.14.16.56.51.76.75.25.31.36.75-.11 1.21L13.05 17.44h9.57c.61-.02 1.2.54 1.2 1.25 0 .63-.51 1.24-1.15 1.24H10.3l-3.76 3.42h16.18c.63 0 1.12.64 1.11 1.25 0 .55-.47 1.22-1.11 1.22h-.1l-18.84.01L0 29.23h32.6c.64 0 1.14.67 1.14 1.24.01.66-.46 1.26-1.12 1.26H0v3.4h32.57c.75.02 1.18.69 1.18 1.3 0 .57-.55 1.18-1.19 1.18H0v3.42h42.49c.71.02 1.16.63 1.14 1.29-.02.58-.5 1.18-1.13 1.18H11.42v3.42h31.21c.57 0 1.07.7 1.07 1.28s-.5 1.2-1.08 1.2h-.63",
      class: "svg-AM-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-AM-logo_svg__path22",
      d: "M22.83 61.13v3.48s4.59.01 7.21 0c6.46-.05 10.69-3.48 10.69-3.48h-17.9",
      class: "svg-AM-logo_svg__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      id: "svg-AM-logo_svg__path24",
      d: "M22.83 55.28v3.4h20.75c.96-.98 2.19-2.75 2.51-3.4H22.83",
      class: "svg-AM-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "AM-logo"}) } }